import React from 'react';
import HeaderOneLine from 'common/components/HeaderOneLine/HeaderOneLine';
import i18n from 'common/locale/i18n';
import DefaultLoadingScreen from 'common/components/DefaultLoadingScreen/DefaultLoadingScreen';
import Loadable from 'common/libs/Loadable/Loadable';

const BusPaxManifestCheckerInformationContainer = Loadable({
  loader: () =>
    import(/* webpackChunkName: "BusPaxManifestCheckerInformation" */ '../containers/BusPaxManifestCheckerInformation'),
  loading: DefaultLoadingScreen,
});

const BusPaxManifestCheckerInformationScreen = ({ navigation }) => (
  <BusPaxManifestCheckerInformationContainer
    paxManifestId={navigation.getParam('paxManifestId', 0)}
  />
);
BusPaxManifestCheckerInformationScreen.navigationOptions = {
  headerTitle: <HeaderOneLine title={i18n.getText('checker_information')} />,
};
export default BusPaxManifestCheckerInformationScreen;
